module.exports = __webpack_public_path__ + "static/media/greenPoppedBalloon.2523da4f.svg";